import { render, staticRenderFns } from "./MissedCall.vue?vue&type=template&id=563c0814&scoped=true"
import script from "./MissedCall.vue?vue&type=script&lang=js"
export * from "./MissedCall.vue?vue&type=script&lang=js"
import style0 from "./MissedCall.vue?vue&type=style&index=0&id=563c0814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c0814",
  null
  
)

export default component.exports